<div
  class="tab-pane fade flex-even active show"
  id="sales"
  role="tabpanel"
  aria-labelledby="sales-tab"
>
  <div class="d-flex flex-column h-100">
    @if (this.counselors$ | async; as counselors) {
      @if ((this.viewIsAllowed$ | async) === true) {
        <div class="row mt-2">
          <div class="col-12 col-md">
            <div class="ps-3">
              <button
                type="button"
                [class]="ButtonType.Primary | buttontypepipe"
                class="btn-sm btn"
                translate
                (click)="openModalAddCounselor()"
              >
                USER_LBL_EXTERNAL_ACCOUNT_ADD
              </button>
            </div>
          </div>
        </div>
      }

      @if (counselors.length > 0) {
        <div class="row mt-2">
          <div class="col">
            <table class="table table-striped border-bottom">
              <thead>
              <tr>
                <th>
                  <a translate>USER_LBL_EXTERNAL_ACCOUNT_COMPANY</a>
                </th>
                <th>
                  <a translate>USER_LBL_EXTERNAL_ACCOUNT_USERNAME</a>
                </th>
                <th>
                  <a translate>USER_LBL_EXTERNAL_ACCOUNT_ACTIONS</a>
                </th>
                <th>
                  <a translate>USER_LBL_EXTERNAL_ACCOUNT_OCEALIZ_INSURANCE_BINDED</a>
                </th>
              </tr>
              </thead>

              <tbody>
                @for (counselor of counselors; track counselor.id) {
                  <tr>
                    <td>{{ counselor.ocealizInsuranceExternalAccountTypeLoc }}</td>
                    <td>{{ counselor.username }}</td>
                    <td>
                      @for (action of counselor.actions; track action.name; let last = $last; ) {
                        <a role='button'
                           (click)="this.triggerAction(action.name, counselor.id)"
                           translate>{{ action.actionName }}{{ last ? '' : ' | ' }}</a>
                      }
                    </td>
                    <td>
                      {{ counselor.ocealizInsuranceLabel }}
                    </td>
                  </tr>
                }
              </tbody>
            </table>
          </div>
        </div>
      }
    }
  </div>
</div>
